import { useState, useCallback, useEffect } from "react";
import { CloudUploadIcon, CrossIcon } from "../../../assets/icons";
import UploadPdfModal from "../../Common/UploadPdfModal/UploadPdfModal";
import { uploadFile } from "../../../api";
import { toast } from "react-toastify";
import PdfImg from "../../../assets/images/pdf_icon.svg";
import axios from "axios";
import config from "../../../config";
import SpinnerLoading from "../../SpinnerLoading/SpinnerLoading";
import { useBrowseFile } from "../../../hooks/useBrowseFile";
import "./UploadArchivioPdf.scss";

const UploadArchivioPdf = ({ idPdfArchivio = [], disabled, onChange }) => {
  const [showModal, setShowModal] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const { handleBrowseFile } = useBrowseFile();

  const openModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleUpload = useCallback(
    async (ev) => {
      const files = ev.target.files;
      closeModal();
      setIsFileUploading(true);

      if (files.length) {
        Array.from(files).forEach(async (file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function () {
            try {
              const uploadedFileId = await uploadFile(file);

              onChange([
                ...idPdfArchivio,
                { id: uploadedFileId, name: file.name },
              ]);
            } catch (error) {
              console.error("Error uploading file.", error);
              toast.error("Error uploading file.");
            } finally {
              setIsFileUploading(false);
            }
          };

          if (!file.name.endsWith(".pdf")) {
            console.error("Unsupported file format.");
            toast.error("Unsupported file format.");
            setIsFileUploading(false);
          }
        });
      }
    },
    [idPdfArchivio, onChange, closeModal]
  );

  const handleRemovePdf = useCallback(
    (fileId) => {
      onChange(idPdfArchivio.filter((item) => item.id !== fileId));
    },
    [idPdfArchivio, onChange]
  );

  return (
    <div className="form-block" id="allegati">
      <div className="form-block-header">
        <p className="form-block-header-title">Allegati</p>
        {disabled ? null : (
          <button className="upload-archivio-btn" onClick={openModal}>
            <CloudUploadIcon />
            <span>Carica PDF</span>
          </button>
        )}
      </div>
      <div>
        {isFileUploading ? (
          <SpinnerLoading isLoading={isFileUploading} />
        ) : null}
        <div className="preveiw-container">
          {idPdfArchivio?.length
            ? idPdfArchivio.map((pdf) => (
                <div key={pdf?.id} className="archivio-pdf-container">
                  <button onClick={() => handleBrowseFile(pdf?.id, "pdf")}>
                    <img src={PdfImg} alt="pdf" />
                    <p>{pdf.name}</p>
                  </button>
                  {disabled ? null : (
                    <span
                      className="pdf-close-icon"
                      onClick={() => handleRemovePdf(pdf?.id)}
                    >
                      <CrossIcon />
                    </span>
                  )}
                </div>
              ))
            : null}
        </div>
      </div>
      <UploadPdfModal
        title={"Upload PDF"}
        showModal={showModal}
        handleUpload={handleUpload}
        closeModal={closeModal}
      />
    </div>
  );
};

export default UploadArchivioPdf;
